export const prodDomain = 'public.paragonone.com';
